export const CabinetLogEvent = {
  CABINET_SEND_LETTER_VIEWED: {
    // [캐비넷 쪽지 보내기] 화면 진입
    ga: 'cabinet_send_letter_viewed',
    amp: 'Cabinet Send Letter - Viewed',
  },
  CABINET_SEND_LETTER_NEXT_BUTTON_CLICKED: {
    // [캐비넷 쪽지 보내기] 다음 버튼 클릭
    ga: 'cabinet_send_letter_next_button_clicked',
    amp: 'Cabinet Send Letter - Next Button Clicked',
  },
  CABINET_SEND_LETTER_CABINET_CREATE_BUTTON_CLICKED: {
    // [캐비넷 쪽지 보내기] 나도 만들기 버튼 클릭
    ga: 'cabinet_send_letter_cabinet_create_button_clicked',
    amp: 'Cabinet Send Letter - Cabinet Create Button Clicked',
  },
  CABINET_SEND_LETTER_LETTER_IMAGE_SELECTED: {
    // [캐비넷 쪽지 보내기] 편지지 선택
    ga: 'cabinet_send_letter_letter_image_selected',
    amp: 'Cabinet Send Letter - Letter Image Selected',
  },
  CABINET_SEND_LETTER_SUBMIT: {
    // [캐비넷 쪽지 보내기] 쪽지 보내기 버튼 클릭
    ga: 'cabinet_send_letter_submit',
    amp: 'Cabinet Send Letter - Submit',
  },
  CABINET_SEND_LETTER_MORE_BUTTON_CLICKED: {
    // [캐비넷 쪽지 보내기] 쪽지 더 보내기 버튼 클릭
    ga: 'cabinet_send_letter_more_button_clicked',
    amp: 'Cabinet Send Letter - More Button Clicked',
  },
  CABINET_CREATE_VIEWED: {
    // [캐비넷 나도 만들기] 화면 진입
    ga: 'cabinet_create_viewed',
    amp: 'Cabinet Create - Viewed',
  },
  CABINET_CREATE_APP_OPEN_BUTTON_CLICKED: {
    // [캐비넷 나도 만들기] 앱 열기 버튼 클릭
    ga: 'cabinet_create_app_open_button_clicked',
    amp: 'Cabinet Create - App Open Button Clicked',
  },
  HOME_CABINET_BANNER_CLICKED: {
    // [홈] 캐비넷 메인 배너 클릭
    ga: 'home_cabinet_banner_clicked',
    amp: 'Home - Cabinet Banner Clicked',
  },
  CABINET_ID_SETTING_VIEWED: {
    // [캐비넷 아이디 설정] 화면 진입
    ga: 'cabinet_id_setting_viewed',
    amp: 'Cabinet ID Setting - Viewed',
  },
  CABINET_ID_SETTING_SUBMIT: {
    // [캐비넷 아이디 설정] 시작하기 버튼 클릭
    ga: 'cabinet_id_setting_submit',
    amp: 'Cabinet ID Setting - Submit',
  },
  CABINET_CREATION_SUCCESS_VIEWED: {
    // [캐비넷 생성 완료] 화면 진입
    ga: 'cabinet_creation_success_viewed',
    amp: 'Cabinet Creation Success - Viewed',
  },
  CABINET_HOME_VIEWED: {
    // [캐비넷 홈] 화면 진입
    ga: 'cabinet_home_viewed',
    amp: 'Cabinet Home - Viewed',
  },
  CABINET_HOME_UPDATE_BUTTON_CLICKED: {
    // [캐비넷 홈] 질문 수정 버튼 클릭
    ga: 'cabinet_home_update_button_clicked',
    amp: 'Cabinet Home - Update Button Clicked',
  },
  CABINET_HOME_RANDOM_BUTTON_CLICKED: {
    // [캐비넷 홈] 새로고침 버튼 클릭
    ga: 'cabinet_home_random_button_clicked',
    amp: 'Cabinet Home - Random Button Clicked',
  },
  CABINET_HOME_INSTA_SHARE_BUTTON_CLICKED: {
    // [캐비넷 홈] 인스타 공유 버튼 클릭
    ga: 'cabinet_home_insta_share_button_clicked',
    amp: 'Cabinet Home - Insta Share Button Clicked',
  },
  CABINET_HOME_COPY_LINK_BUTTON_CLICKED: {
    // [캐비넷 홈] 링크 복사 버튼 클릭
    ga: 'cabinet_home_copy_link_button_clicked',
    amp: 'Cabinet Home - Copy Link Button Clicked',
  },
  CABINET_TAB_BAR_CLICKED: {
    // [캐비넷] 탭바 클릭
    ga: 'cabinet_tab_bar_clicked',
    amp: 'Cabinet - Tab Bar Clicked',
  },
  CABINET_UPDATE_RANDOM_BUTTON_CLICKED: {
    // [캐비넷 수정] 랜덤 버튼 클릭
    ga: 'cabinet_update_random_button_clicked',
    amp: 'Cabinet Update - Random Button Clicked',
  },
  CABINET_UPDATE_THEME_COLOR_SELECTED: {
    // [캐비넷 수정] 테마 색상 선택
    ga: 'cabinet_update_theme_color_selected',
    amp: 'Cabinet Update - Theme Color Selected',
  },
  CABINET_UPDATE_UPDATE_BUTTON_CLICKED: {
    // [캐비넷 수정] 수정 버튼 클릭
    ga: 'cabinet_update_update_button_clicked',
    amp: 'Cabinet Update - Update Button Clicked',
  },
  CABINET_UPDATE_SUBMIT: {
    // [캐비넷 수정] 완료 버튼 클릭
    ga: 'cabinet_update_submit',
    amp: 'Cabinet Update - Submit',
  },
  CABINET_GUIDE_VIEWED: {
    // [캐비넷 설명서] 모달 진입
    ga: 'cabinet_guide_viewed',
    amp: 'Cabinet Guide - Viewed',
  },
  CABINET_GUIDE_NEXT_BUTTON_CLICKED: {
    // [캐비넷 설명서] 다음 버튼 클릭
    ga: 'cabinet_guide_next_button_clicked',
    amp: 'Cabinet Guide - Next Button Clicked',
  },
  CABINET_GUIDE_INSTA_SHARE_BUTTON_CLICKED: {
    // [캐비넷 설명서] 공유 버튼 클릭
    ga: 'cabinet_guide_insta_share_button_clicked',
    amp: 'Cabinet Guide - Insta Share Button Clicked',
  },
  CABINET_GUIDE_REFUSE_BUTTON_CLICKED: {
    // [캐비넷 설명서] 다시 보지 않기 버튼 클릭
    ga: 'cabinet_guide_refuse_button_clicked',
    amp: 'Cabinet Guide - Refuse Button Clicked',
  },
  CABINET_HISTORY_VIEWED: {
    // [캐비넷 히스토리] 화면 진입
    ga: 'cabinet_history_viewed',
    amp: 'Cabinet History - Viewed',
  },
  CABINET_HISTORY_SCROLLED: {
    // [캐비넷 히스토리] 스크롤
    ga: 'cabinet_history_scrolled',
    amp: 'Cabinet History - Scrolled',
  },
  CABINET_HISTORY_LETTER_CLICKED: {
    // [캐비넷 히스토리] 쪽지 클릭
    ga: 'cabinet_history_letter_clicked',
    amp: 'Cabinet History - Letter Clicked',
  },
  CABINET_HISTORY_INSTALL_APP_CLICKED: {
    // [캐비넷 히스토리] 앱 설치하고 쪽지확인하기 버튼 클릭
    ga: 'cabinet_history_install_app_clicked',
    amp: 'Cabinet History - Install App Clicked'
  },
  CABINET_LETTER_DETAIL_VIEWED: {
    // [캐비넷 쪽지 디테일] 화면 진입
    ga: 'cabinet_letter_detail_viewed',
    amp: 'Cabinet Letter Detail - Viewed',
  },
  CABINET_LETTER_DETAIL_HINT_BUTTON_CLICKED: {
    // [캐비넷 쪽지 디테일] 한트 보기 클릭
    ga: 'cabinet_letter_detail_hint_button_clicked',
    amp: 'Cabinet Letter Detail - Hint Button Clicked',
  },
  CABINET_LETTER_HINT_VIEWED: {
    // [캐비넷 쪽지 힌트] 화면 진입
    ga: 'cabinet_letter_hint_viewed',
    amp: 'Cabinet Letter Hint - Viewed',
  },
  CABINET_LETTER_DETAIL_INSTA_REPLY_BUTTON_CLICKED: {
    // [캐비넷 쪽지 디테일] 인스타 답장하기 버튼 클릭
    ga: 'cabinet_letter_detail_insta_reply_button_clicked',
    amp: 'Cabinet Letter Detail - Insta Reply Button Clicked',
  },
  CABINET_ONBOARDING_VIEWED: {
    // [캐비넷 온보딩] 화면 진입
    ga: 'cabinet_onboarding_viewed',
    amp: 'Cabinet Onboarding - Viewed',
  },
  CABINET_ONBOARDING_SUBMIT: {
    // [캐비넷 온보딩] 시작하기 버튼 클릭
    ga: 'cabinet_onboarding_submit',
    amp: 'Cabinet Onboarding - Submit',
  },
}
